import React from 'react';
import { MapPin, Navigation } from 'lucide-react';

const ServiceArea: React.FC = () => {
  return (
    <section className="py-24 bg-white overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          {/* Text Content */}
          <div className="w-full lg:w-1/2 space-y-8">
            <div className="inline-flex items-center space-x-2 bg-brand-blue/10 text-brand-blue px-4 py-2 rounded-full">
              <MapPin className="w-4 h-4" />
              <span className="text-xs font-bold uppercase tracking-wider">Local Service</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy leading-tight">
              Proudly Serving <span className="text-brand-blue">Hudson County</span>
            </h2>

            <p className="text-lg text-brand-navy/70 leading-relaxed">
              We are local experts who know Jersey City and Hoboken inside and out.
              Our teams are strategically located to provide prompt, reliable service
              to our neighbors across the county.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              <div className="p-6 bg-brand-gray-50 rounded-2xl border border-gray-100">
                <h4 className="font-bold text-brand-navy mb-2">Jersey City</h4>
                <p className="text-sm text-brand-navy/60">Downtown, Heights, Journal Square, Bergen-Lafayette, and more.</p>
              </div>
              <div className="p-6 bg-brand-gray-50 rounded-2xl border border-gray-100">
                <h4 className="font-bold text-brand-navy mb-2">Hoboken</h4>
                <p className="text-sm text-brand-navy/60">Full coverage across the Mile Square City, from the Waterfront to the West Side.</p>
              </div>
            </div>

            <div className="flex items-center space-x-4 p-4 bg-brand-blue/5 rounded-xl border border-brand-blue/10">
              <Navigation className="w-6 h-6 text-brand-blue" />
              <p className="text-sm font-medium text-brand-navy">
                Don't see your neighborhood? <a href="/#quote-form" className="text-brand-blue underline">Contact us</a> to check availability.
              </p>
            </div>
          </div>

          {/* Real Google Maps Embed */}
          <div className="w-full lg:w-1/2 relative">
            <div className="aspect-square md:aspect-video lg:aspect-square rounded-[2.5rem] overflow-hidden shadow-premium border-8 border-white">
              <iframe
                title="CleanHouseNJ Service Area"
                width="100%"
                height="100%"
                style={{ border: 0, filter: 'grayscale(100%)' }}
                loading="lazy"
                allowFullScreen
                referrerPolicy="no-referrer-when-downgrade"
                src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d24196.45!2d-74.0431!3d40.7282!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1sen!2sus!4v1"
              />
            </div>

            {/* Service Active Badge */}
            <div className="absolute top-8 left-8 bg-white p-4 rounded-2xl shadow-lg border border-gray-100 max-w-[200px]">
              <div className="flex items-center space-x-3 mb-2">
                <div className="w-3 h-3 bg-brand-blue rounded-full animate-pulse"></div>
                <span className="text-xs font-bold text-brand-navy">Service Active</span>
              </div>
              <p className="text-[10px] text-brand-navy/60">Our cleaners are currently active in your area.</p>
            </div>

            {/* Decorative blurs */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-brand-red/10 rounded-full blur-3xl"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-brand-blue/10 rounded-full blur-3xl"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceArea;
